import React, { useEffect, useMemo } from "react";
import DashboardLayout from "../../../../layouts/DashboardLayout";
import useStyles from "./styles";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  getStandardsQuestionnaire,
  listAssessmentCycle,
  viewStandardsQuestionnaireAnswer,
} from "../../../../redux/actions";
import BrsrView from "./BrsrView";
import { brsrTableRegistry } from "./brsrtables";

function ViewQuestionnaire() {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const data = useSelector(
    (state) => state.assessment.viewStandardsQuestionnaireAnswer.data
  );
  const isTableEmpty = (answer) => {
    if (!answer) return true; // If answer is null or undefined, it's empty
    if (Array.isArray(answer)) {
      if (answer.length === 0) return true; // Empty array
      return answer.every((row) => {
        if (!row) return true; // If row is null or undefined, it's empty
        return Object.values(row).every(
          (value) => String(value || "").trim() === ""
        );
      });
    }
    if (typeof answer === "object") {
      return Object.values(answer).every(
        (value) => String(value || "").trim() === ""
      );
    }
    return true;
  };

  const requestData = useMemo(
    () => ({
      framework_id: location.state.framework_id,
      questionnaire_id: location.state.questionnaire_id,
    }),
    []
  );

  useEffect(() => {
    dispatch(viewStandardsQuestionnaireAnswer(requestData));
    dispatch(listAssessmentCycle());
  }, [requestData]);

  const assessmentList = useSelector(
    (state) => state.assessment.assessmentList.data
  );

  const filteredData = data?.answer?.filter((item) => {
    if (item.question_type === "table") {
      const isEmpty = isTableEmpty(item.answer);
      return !isEmpty;
    }
    return (
      (item.answer !== "" && item.answer !== null) || item.question_type === ""
    );
  });

  const questionsData = useSelector((state) => {
    const data = state.emission.getStandardsQuestionnaire.data.questions_list;
    return Array.isArray(data) ? data : [];
  });

  useEffect(() => {
    const filteredList =
      assessmentList?.filter(
        (item) =>
          item.assessment_year === data.assessment_year &&
          item.country === data.country_code
      ) || [];
    const assessment_id = filteredList[0]?.id;

    if (assessment_id) {
      dispatch(
        getStandardsQuestionnaire(
          location.state.framework_id || "67580e50d845c48ffba61868",
          assessment_id
        )
      );
    }
  }, [dispatch, data]);
  const navigateBack = () => {
    navigate(-1);
  };
  const renderTCFDTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          {/* Check if category exists and conditionally render headers */}
          {answer.some((item) => item.category) ? (
            // Table Header when category exists
            <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
              <TableCell sx={{ border: 1, fontWeight: 520 }}>
                Category
              </TableCell>
              <TableCell sx={{ border: 1, fontWeight: 520 }}>Risks</TableCell>
              <TableCell sx={{ border: 1, fontWeight: 520 }}>
                Potential Impacts (Pre-defined)
              </TableCell>
              <TableCell sx={{ border: 1, fontWeight: 520 }}>
                Time period (Short/Medium/Long)
              </TableCell>
              <TableCell sx={{ border: 1, fontWeight: 520 }}>
                Applicable to Your Organisation? (Yes/ NO)
              </TableCell>
              <TableCell sx={{ border: 1, fontWeight: 520 }}>
                Comments/Additional Details
              </TableCell>
            </TableRow>
          ) : (
            // Table Header when category is missing
            <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
              <TableCell sx={{ border: 1, fontWeight: 520 }}>
                Scenario
              </TableCell>
              <TableCell sx={{ border: 1, fontWeight: 520 }}>
                Description of Scenario
              </TableCell>
              <TableCell sx={{ border: 1, fontWeight: 520 }}>
                Key Risks Identified
              </TableCell>
              <TableCell sx={{ border: 1, fontWeight: 520 }}>
                Key Opportunities Identified
              </TableCell>
              <TableCell sx={{ border: 1, fontWeight: 520 }}>
                Resilience Strategies
              </TableCell>
              <TableCell sx={{ border: 1, fontWeight: 520 }}>
                Gaps or Challenges Identified
              </TableCell>
            </TableRow>
          )}
        </TableHead>
        <TableBody>
          {answer.map((categoryData, idx) =>
            // If `category` is present
            categoryData.category
              ? categoryData.risks.map((riskData, riskIdx) => (
                  <TableRow key={`${idx}-${riskIdx}`}>
                    {riskIdx === 0 && (
                      <TableCell
                        rowSpan={categoryData.risks.length}
                        sx={{ border: 1 }}
                      >
                        {categoryData.category}
                      </TableCell>
                    )}
                    <TableCell sx={{ border: 1 }}>{riskData.risk}</TableCell>
                    <TableCell sx={{ border: 1 }}>{riskData.impacts}</TableCell>
                    <TableCell sx={{ border: 1 }}>
                      {riskData.timePeriod}
                    </TableCell>
                    <TableCell sx={{ border: 1 }}>
                      {riskData.applicable}
                    </TableCell>
                    <TableCell sx={{ border: 1 }}>
                      {riskData.comments}
                    </TableCell>
                  </TableRow>
                ))
              : // If `category` is missing
                categoryData.risks.map((riskData, riskIdx) => (
                  <TableRow key={`${idx}-${riskIdx}`}>
                    <TableCell sx={{ border: 1 }}>{riskData.risk}</TableCell>
                    <TableCell sx={{ border: 1 }}>{riskData.impacts}</TableCell>
                    <TableCell sx={{ border: 1 }}>{riskData.keyRisk}</TableCell>
                    <TableCell sx={{ border: 1 }}>
                      {riskData.keyOpportunity}
                    </TableCell>
                    <TableCell sx={{ border: 1 }}>
                      {riskData.resilience}
                    </TableCell>
                    <TableCell sx={{ border: 1 }}>
                      {riskData.gapsChallenges}
                    </TableCell>
                  </TableRow>
                ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
  const renderAssetValueTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Total Number Of Operations
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Net Sales</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Total Number Of Product Or Services Provided
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Total Assets
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow key={`${1}`}>
            <TableCell sx={{ border: 1 }}>
              {answer?.totalNumberOfOperations}
            </TableCell>
            <TableCell sx={{ border: 1 }}>{answer?.netSales}</TableCell>
            <TableCell sx={{ border: 1 }}>
              {answer?.totalNumberOfProductOrServicesProvided}
            </TableCell>
            <TableCell sx={{ border: 1 }}>{answer?.totalAssets}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
  const renderMarketReservedTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          {/* Check if category exists and conditionally render headers */}
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Market Served
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Graphic BreakDown
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Sectors Served
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((ans, riskIdx) => (
            <TableRow key={`${riskIdx}`}>
              <TableCell sx={{ border: 1 }}>{ans?.marketServed}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.graphicBreakDown}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.sectorsServed}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
  const renderSupplierTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          {/* Check if category exists and conditionally render headers */}
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Supplier Name
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Supplier Type
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Activities Type
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Business Type
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Payment Type
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Location Type
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((ans, riskIdx) => (
            <TableRow key={`${riskIdx}`}>
              <TableCell sx={{ border: 1 }}>{ans?.supplierName}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.supplierType}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.activitiesType}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.businessType}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.paymentType}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.locationType}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
  const renderDownStreamTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          {/* Check if category exists and conditionally render headers */}
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              DownStream Name
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              DownStream Type
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Activities Type
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Business Type
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Location Type
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((ans, riskIdx) => (
            <TableRow key={`${riskIdx}`}>
              <TableCell sx={{ border: 1 }}>{ans?.downstreamName}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.downstreamType}</TableCell>
              <TableCell sx={{ border: 1 }}>
                {ans?.downstreamActivityType}
              </TableCell>
              <TableCell sx={{ border: 1 }}>
                {ans?.downstreamBusinessType}
              </TableCell>
              <TableCell sx={{ border: 1 }}>
                {ans?.downstreamLocationType}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
  const renderLawRegulationsTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Sl. No.</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Instance</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Reporting period
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Type of Instance
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Geographic location
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Frequency</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Severity</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Fine paid</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((ans, riskIdx) => (
            <TableRow key={`${riskIdx}`}>
              <TableCell sx={{ border: 1 }}>{riskIdx + 1}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.instance}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.reportingPeriod}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.instanceType}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.lawLocationType}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.frequency}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.severity}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.finePaid}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderMaterialTopicsTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Sl. No.</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Topic</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Impact</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Actual Potential
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              ImpactType
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Time Frame
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Affected Resources
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Location</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((ans, riskIdx) => (
            <TableRow key={`${riskIdx}`}>
              <TableCell sx={{ border: 1 }}>{riskIdx + 1}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.materialTopic}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.materialImpact}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.actualPotential}</TableCell>
              <TableCell sx={{ border: 1 }}>
                {ans?.materialImpactType}
              </TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.materialTimeFrame}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.affectedResources}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.materialLocation}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderCorruptionTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Country Name
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Corruption Risk Level ('E' or 'F')
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Revenue</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Business Ethics Risks Present (Yes/No)
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Mitigation Measures Taken
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((ans, riskIdx) => (
            <TableRow key={`${riskIdx}`}>
              {/* <TableCell sx={{ border: 1 }}>{riskIdx + 1}</TableCell> */}
              <TableCell sx={{ border: 1 }}>{ans?.countryName}</TableCell>
              <TableCell sx={{ border: 1 }}>
                {ans?.corruptionRiskLevel}
              </TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.revenue}</TableCell>
              <TableCell sx={{ border: 1 }}>
                {ans?.businessEthicsRisk}
              </TableCell>
              <TableCell sx={{ border: 1 }}>
                {ans?.mitigationMeasures}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderForestLandTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Area Type</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Area (hectares)
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Management Status (Managed/Unmanaged)
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Certified Status (Yes/No)
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Certification Type
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((ans, riskIdx) => (
            <TableRow key={`${riskIdx}`}>
              {/* <TableCell sx={{ border: 1 }}>{riskIdx + 1}</TableCell> */}
              <TableCell sx={{ border: 1 }}>{ans?.areaType}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.areaHectares}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.managementStatus}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.certifiedStatus}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.certificationType}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderStrikesTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Strike/Lockout
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Number of Workers Involved
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Duration (Days Idle)
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Cause of Work Stoppage
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Impact on Production
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Corrective Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((ans, riskIdx) => (
            <TableRow key={`${riskIdx}`}>
              {/* <TableCell sx={{ border: 1 }}>{riskIdx + 1}</TableCell> */}
              <TableCell sx={{ border: 1 }}>{ans?.strikeLockout}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.numberOfWorkers}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.durationDays}</TableCell>
              <TableCell sx={{ border: 1 }}>
                {ans?.causeOfWorkStoppage}
              </TableCell>
              <TableCell sx={{ border: 1 }}>
                {ans?.impactOnProduction}
              </TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.correctiveActions}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderworkforceTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Metric</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Direct Employees
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Contact Employees
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((ans, riskIdx) => (
            <TableRow key={`${riskIdx}`}>
              {/* <TableCell sx={{ border: 1 }}>{riskIdx + 1}</TableCell> */}
              <TableCell sx={{ border: 1 }}>{ans?.metric}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.directEmployees}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.contactEmployees}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderWorkforceTable1 = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Metric</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Direct Employees
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Contact Employees
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((ans, idx) => (
            <TableRow key={`${idx}`}>
              <TableCell sx={{ border: 1 }}>{ans?.metric}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.directEmployees}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.contactEmployees}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderPollutantEmissionTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Pollutant</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Emission (metric tons)
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((ans, riskIdx) => (
            <TableRow key={`${riskIdx}`}>
              <TableCell sx={{ border: 1 }}>{ans?.Pollutant}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.Emission}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderEmployeeCategoryTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Employee Category
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Women (%)</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Men (%)</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Others (%)
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Not Disclosed (%)
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((ans, riskIdx) => (
            <TableRow key={`${riskIdx}`}>
              <TableCell sx={{ border: 1 }}>{ans?.EmployeeCategory}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.Women}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.Men}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.Others}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.NotDisclosed}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderEmployeeCategoryTable1 = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Employee Category
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Group 1 (%)
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Group 2 (%)
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Group 3 (%)
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Not Disclosed (%)
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((ans, riskIdx) => (
            <TableRow key={`${riskIdx}`}>
              <TableCell sx={{ border: 1 }}>{ans?.EmployeeCategory}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.Group1}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.Group2}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.Group3}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.NotDisclosed}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderRawSteelProductionTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Raw Steel Production
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              (metric tons cast)
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((ans, riskIdx) => (
            <TableRow key={`${riskIdx}`}>
              <TableCell sx={{ border: 1 }}>{ans?.process}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderProcessSafetyMetricsTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Metric</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Year</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((ans, riskIdx) => (
            <TableRow key={`${riskIdx}`}>
              <TableCell sx={{ border: 1 }}>{ans?.metric}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans?.year}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderResilienceTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 600 }}>Scenario</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 600 }}>
              Description of Scenario
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 600 }}>
              Key Risks Identified
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 600 }}>
              Key Opportunities Identified
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 600 }}>
              Resilience Strategies
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 600 }}>
              Gaps or Challenges Identified
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((ans, riskIdx) => (
            <TableRow key={`${riskIdx}`}>
              <TableCell sx={{ border: 1 }}>{ans.risk}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans.impacts}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans.keyRisk}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans.keyOpportunity}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans.resilience}</TableCell>
              <TableCell sx={{ border: 1 }}>{ans.gapsChallenges}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderGenTable = (answer) => {
    const refer = [
      "Excecutive Management",
      "Non Excecutive Management",
      "Professionals",
      "All other Employees",
    ];
    const headRefer = {
      male: "Male",
      female: "Female",
      other: "Other",
      notDisclosed: "Not disclosed",
      groupA: "Group A",
      groupB: "Group B",
      groupC: "Group C",
      NA: "NA",
    };
    const firstRecord = Object.keys(answer);
    const secondOrderKeys = Object.keys(answer[firstRecord[0]]);
    return (
      <TableContainer
        sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
      >
        <Table sx={{ borderRadius: 1 }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
              <TableCell sx={{ border: 1, fontWeight: 600 }}></TableCell>
              {secondOrderKeys.map((item) => (
                <TableCell sx={{ border: 1, fontWeight: 600 }}>
                  {headRefer[item]}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {firstRecord.map((ans, riskIdx) => {
              const subkeys = Object.keys(answer[ans]);
              return (
                <TableRow key={`${riskIdx}`}>
                  <TableCell sx={{ border: 1 }}>{refer[riskIdx]}</TableCell>
                  <TableCell sx={{ border: 1 }}>
                    {answer[ans][subkeys[0]]}
                  </TableCell>
                  <TableCell sx={{ border: 1 }}>
                    {answer[ans][subkeys[1]]}
                  </TableCell>
                  <TableCell sx={{ border: 1 }}>
                    {answer[ans][subkeys[2]]}
                  </TableCell>
                  <TableCell sx={{ border: 1 }}>
                    {answer[ans][subkeys[3]]}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const renderInitiativeTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Initiative Name
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Type of Support
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Start/End Date
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Status</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Priority Country
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Priority Disease
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Description
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((row, idx) => (
            <TableRow key={idx}>
              <TableCell sx={{ border: 1 }}>{row?.initiativeName}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.typeOfSupport}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.startEndDate}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.status}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.priorityCountry}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.priorityDisease}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.description}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderDrugTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              International Non-Proprietary Name (INN)
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Brand Name (if applicable)
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Formulation (e.g., tablet, capsule)
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Strength</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              WHO Therapeutic Area (e.g., HIV, malaria)
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((row, idx) => (
            <TableRow key={idx}>
              <TableCell sx={{ border: 1 }}>{row?.inn}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.brandName}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.formulation}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.strength}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.therapeuticArea}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderWorkforceTurnoverTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Categories
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Voluntary Turnover (%)
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Involuntary Turnover (%)
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Classification Standard Used (e.g., ISCO or internal)
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((row, idx) => (
            <TableRow key={idx}>
              <TableCell sx={{ border: 1 }}>{row?.category}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.voluntaryTurnover}</TableCell>
              <TableCell sx={{ border: 1 }}>
                {row?.involuntaryTurnover}
              </TableCell>
              <TableCell sx={{ border: 1 }}>
                {row?.classificationStandard}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  //BRSR TABLES

  const renderTotalEmployeesTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Category</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Total</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Female</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Male</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Non-Binary
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((row, idx) => (
            <TableRow key={idx}>
              <TableCell sx={{ border: 1 }}>{row?.category}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.total}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.female}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.male}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.nonBinary}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderWorkforceGenderTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Employee Category
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Women (%)</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Men (%)</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Not Disclosed (%)
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((row, idx) => (
            <TableRow key={idx}>
              <TableCell sx={{ border: 1 }}>{row?.category}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.female}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.male}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.notDisclosed}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderWorkforceGroupTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Category</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Group A (%)
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Group B (%)
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Group C (%)
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Not disclosed (%)
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((row, idx) => (
            <TableRow key={idx}>
              <TableCell sx={{ border: 1 }}>{row?.category}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.groupA}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.groupB}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.groupC}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.notDisclosed}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderFleetFuelEconomyTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Region</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Unit</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Average Fleet Fuel Economy
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((row, idx) => (
            <TableRow key={idx}>
              <TableCell sx={{ border: 1 }}>{row?.region}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.unit}</TableCell>
              <TableCell sx={{ border: 1 }}>
                {row?.averageFleetFuelEconomy ?? row?.avgFleetFuelEconomy}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderMortgageSummaryTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}></TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Number</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Loan value
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(Array.isArray(answer) ? answer : []).map((row, idx) => (
            <TableRow key={idx}>
              <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                {row?.item}
              </TableCell>
              <TableCell sx={{ border: 1 }}>{row?.number}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.loanValue}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderLoanResolutionTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}></TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>Number</TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Loan value
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(Array.isArray(answer) ? answer : []).map((row, idx) => (
            <TableRow key={idx}>
              <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                {
                  row?.item /* e.g., "Modification", "Foreclosure", "Short sale/deed in lieu" */
                }
              </TableCell>
              <TableCell sx={{ border: 1 }}>{row?.number}</TableCell>
              <TableCell sx={{ border: 1 }}>{row?.loanValue}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderBorrowerLTVTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Borrower Type
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Number of Loans
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Total Loan Value
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Weighted Avg Loan-to-Value (%)
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(Array.isArray(answer) ? answer : []).map((row, idx) => (
            <TableRow key={idx}>
              <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                {
                  row?.borrowerType /* e.g., "Minority Borrowers", "All Other Borrowers" */
                }
              </TableCell>
              <TableCell sx={{ border: 1 }}>
                {row?.numberOfLoans ?? row?.numLoans}
              </TableCell>
              <TableCell sx={{ border: 1 }}>{row?.totalLoanValue}</TableCell>
              <TableCell sx={{ border: 1 }}>
                {row?.weightedAvgLTV ?? row?.weightedAvgLoanToValue}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderProjectDelayTable = (answer) => (
    <TableContainer
      sx={{ marginBottom: 3, borderRadius: 1, overflow: "hidden" }}
    >
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Project Name
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Number of Delays
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Total Duration (Days)
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Root Cause
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Corrective Actions
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520 }}>
              Status (Ongoing/Resolved)
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answer.map((row, idx) => (
            <TableRow key={idx}>
              <TableCell sx={{ border: 1 }}>{row?.projectName}</TableCell>
              <TableCell sx={{ border: 1 }}>
                {row?.numberOfDelays ?? row?.numDelays}
              </TableCell>
              <TableCell sx={{ border: 1 }}>
                {row?.totalDurationDays ?? row?.totalDuration}
              </TableCell>
              <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                {row?.rootCause}
              </TableCell>
              <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                {row?.correctiveActions}
              </TableCell>
              <TableCell sx={{ border: 1 }}>{row?.status}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  //ifrs tables
  const renderRiskOpportunityTimeHorizonTable = (answer = []) => (
    <TableContainer sx={{ mb: 3, borderRadius: 1, overflow: "hidden" }}>
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell
              sx={{
                border: 1,
                fontWeight: 520,
                textAlign: "center",
                width: 80,
              }}
            >
              S.
              <br />
              NO.
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Risk/Opportunity
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Description of
              <br />
              Risk/Opportunity
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Time Horizon
              <br />
              (Short / Medium / Long)
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Definition of
              <br />
              Time Horizon
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Comments/Additional
              <br />
              Details
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {answer.map((row, idx) => {
            // Flexible field fallbacks
            const risk =
              row?.ro ??
              row?.riskOrOpportunity ??
              row?.risk ??
              row?.opportunity ??
              "";
            const description =
              row?.description ??
              row?.descriptionOfRiskOpportunity ??
              row?.desc ??
              "";
            const timeHorizon = row?.timeHorizon ?? row?.horizon ?? "";
            const defTH =
              row?.timeHorizonDefinition ?? row?.definitionOfTimeHorizon ?? "";
            const comments =
              row?.comments ?? row?.additionalDetails ?? row?.notes ?? "";

            return (
              <TableRow key={idx}>
                <TableCell sx={{ border: 1 }}>{idx + 1}.</TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {risk}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {description}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {timeHorizon}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {defTH}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {comments}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderRiskOpportunityEffectsTable = (answer = []) => (
    <TableContainer sx={{ mb: 3, borderRadius: 1, overflow: "hidden" }}>
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell
              sx={{
                border: 1,
                fontWeight: 520,
                textAlign: "center",
                width: 80,
              }}
            >
              S.
              <br />
              NO.
            </TableCell>

            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Risk/Opportunity
            </TableCell>

            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Current Effects on
              <br />
              Business Model/Value Chain
            </TableCell>

            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Anticipated
              <br />
              Future Effects
            </TableCell>

            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Area of Concentration
              <br />
              <span style={{ fontStyle: "italic" }}>
                (Geography, Facility,
                <br />
                Asset Type)
              </span>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {answer.map((row, idx) => {
            const risk =
              row?.riskOrOpportunity ??
              row?.ro ??
              row?.risk ??
              row?.opportunity ??
              "";
            const current =
              row?.currentEffects ??
              row?.currentEffectsOnBusiness ??
              row?.currentEffectsOnValueChain ??
              "";
            const future =
              row?.anticipatedEffects ??
              row?.anticipatedFutureEffects ??
              row?.futureEffects ??
              "";
            const area =
              row?.areaOfConcentration ??
              row?.concentrationArea ??
              row?.area ??
              "";

            return (
              <TableRow key={idx}>
                <TableCell sx={{ border: 1 }}>{idx + 1}.</TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {risk}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {current}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {future}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {area}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
  const renderRiskActionsProgressTable = (answer = []) => (
    <TableContainer sx={{ mb: 3, borderRadius: 1, overflow: "hidden" }}>
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell
              sx={{
                border: 1,
                fontWeight: 520,
                textAlign: "center",
                width: 80,
              }}
            >
              S.
              <br />
              NO.
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Risk/Opportunity
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Actions Taken
              <br />
              (Past Response)
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Planned Actions
              <br />
              (Future Response)
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Progress Since Last
              <br />
              Reporting (Quantitative
              <br />& Qualitative)
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {answer.map((row, idx) => {
            const risk =
              row?.riskOrOpportunity ??
              row?.ro ??
              row?.risk ??
              row?.opportunity ??
              "";
            const past =
              row?.actionsTakenPast ??
              row?.pastResponse ??
              row?.actionsTaken ??
              "";
            const future =
              row?.plannedActionsFuture ??
              row?.futureResponse ??
              row?.plannedActions ??
              "";
            const progress =
              row?.progressSinceLast ??
              row?.progressQuantQual ??
              row?.progress ??
              "";

            return (
              <TableRow key={idx}>
                <TableCell sx={{ border: 1 }}>{idx + 1}.</TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {risk}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {past}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {future}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {progress}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderFinancialEffectsRiskTable = (answer = []) => (
    <TableContainer sx={{ mb: 3, borderRadius: 1, overflow: "hidden" }}>
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell
              sx={{
                border: 1,
                fontWeight: 520,
                textAlign: "center",
                width: 80,
              }}
            >
              S.
              <br />
              NO.
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Risk/Opportunity
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Effects on
              <br />
              entity’s financial
              <br />
              position
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Effects on
              <br />
              entity’s financial
              <br />
              performance
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Effects on
              <br />
              entity’s cash
              <br />
              flows
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Significant risk of a material adjustment to the carrying amounts
              of assets and liabilities in the next annual reporting period?
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {answer.map((row, idx) => {
            const risk =
              row?.riskOrOpportunityFE ??
              row?.riskOrOpportunity ??
              row?.ro ??
              row?.risk ??
              row?.opportunity ??
              "";

            const pos =
              row?.effectsFinancialPosition ??
              row?.effectsOnFinancialPosition ??
              row?.financialPositionEffects ??
              "";

            const perf =
              row?.effectsFinancialPerformance ??
              row?.effectsOnFinancialPerformance ??
              row?.financialPerformanceEffects ??
              "";

            const cash =
              row?.effectsCashFlows ??
              row?.effectsOnCashFlows ??
              row?.cashFlowEffects ??
              "";

            const matAdj =
              row?.significantRiskMaterialAdjustment ??
              row?.significantRiskOfMaterialAdjustment ??
              row?.materialAdjustmentRiskNextPeriod ??
              row?.materialAdjustmentRisk ??
              "";

            return (
              <TableRow key={idx}>
                <TableCell sx={{ border: 1 }}>{idx + 1}.</TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {risk}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {pos}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {perf}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {cash}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {matAdj}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderTimeHorizonABCTable = (answer = []) => (
    <TableContainer sx={{ mb: 3, borderRadius: 1, overflow: "hidden" }}>
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell
              rowSpan={2}
              sx={{
                border: 1,
                fontWeight: 520,
                textAlign: "center",
                width: 80,
              }}
            >
              S.
              <br />
              NO.
            </TableCell>
            <TableCell
              rowSpan={2}
              sx={{ border: 1, fontWeight: 520, textAlign: "center" }}
            >
              Risk/Opportunity
            </TableCell>
            <TableCell
              colSpan={3}
              sx={{ border: 1, fontWeight: 520, textAlign: "center" }}
            >
              Short Term
            </TableCell>
            <TableCell
              colSpan={3}
              sx={{ border: 1, fontWeight: 520, textAlign: "center" }}
            >
              Medium Term
            </TableCell>
            <TableCell
              colSpan={3}
              sx={{ border: 1, fontWeight: 520, textAlign: "center" }}
            >
              Long Term
            </TableCell>
          </TableRow>

          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              A
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              B
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              C
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              A
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              B
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              C
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              A
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              B
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              C
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {answer.map((row, idx) => {
            const risk =
              row?.riskOrOpportunityABC ??
              row?.riskOrOpportunity ??
              row?.ro ??
              row?.risk ??
              row?.opportunity ??
              "";

            const shortA = row?.shortA ?? row?.shortTermA ?? row?.short_a ?? "";
            const shortB = row?.shortB ?? row?.shortTermB ?? row?.short_b ?? "";
            const shortC = row?.shortC ?? row?.shortTermC ?? row?.short_c ?? "";

            const mediumA =
              row?.mediumA ?? row?.mediumTermA ?? row?.medium_a ?? "";
            const mediumB =
              row?.mediumB ?? row?.mediumTermB ?? row?.medium_b ?? "";
            const mediumC =
              row?.mediumC ?? row?.mediumTermC ?? row?.medium_c ?? "";

            const longA = row?.longA ?? row?.longTermA ?? row?.long_a ?? "";
            const longB = row?.longB ?? row?.longTermB ?? row?.long_b ?? "";
            const longC = row?.longC ?? row?.longTermC ?? row?.long_c ?? "";

            return (
              <TableRow key={idx}>
                <TableCell sx={{ border: 1 }}>{idx + 1}.</TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {risk}
                </TableCell>

                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {shortA}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {shortB}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {shortC}
                </TableCell>

                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {mediumA}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {mediumB}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {mediumC}
                </TableCell>

                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {longA}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {longB}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {longC}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderSustainabilityRiskAssessmentTable = (answer = []) => (
    <TableContainer sx={{ mb: 3, borderRadius: 1, overflow: "hidden" }}>
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell
              sx={{
                border: 1,
                fontWeight: 520,
                textAlign: "center",
                width: 80,
              }}
            >
              S.
              <br />
              No.
            </TableCell>

            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Sustainability-
              <br />
              Related Risk
            </TableCell>

            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Time Horizon
              <br />
              (Short / Medium / Long)
            </TableCell>

            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Qualitative
              <br />
              Assessment
            </TableCell>

            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Quantitative
              <br />
              Assessment (Single
              <br />
              value or range, if
              <br />
              available)
            </TableCell>

            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              How the
              <br />
              Assessment Was
              <br />
              Carried Out?
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {answer.map((row, idx) => {
            const risk =
              row?.sustainabilityRelatedRiskSR ??
              row?.sustainabilityRelatedRisk ??
              row?.risk ??
              "";
            const horizon =
              row?.timeHorizonSMLSR ?? row?.timeHorizon ?? row?.horizon ?? "";
            const qual =
              row?.qualitativeAssessmentSR ??
              row?.qualitativeAssessment ??
              row?.qualitative ??
              "";
            const quant =
              row?.quantitativeAssessmentSR ??
              row?.quantitativeAssessment ??
              row?.quantitative ??
              "";
            const method =
              row?.assessmentMethodSR ??
              row?.howAssessmentCarriedOut ??
              row?.assessmentMethod ??
              "";

            return (
              <TableRow key={idx}>
                <TableCell sx={{ border: 1 }}>{idx + 1}.</TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {risk}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {horizon}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {qual}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {quant}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {method}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderTargetsDisclosureViewTable = (answer = []) => (
    <TableContainer sx={{ mb: 3, borderRadius: 1, overflow: "hidden" }}>
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell
              sx={{
                border: 1,
                fontWeight: 520,
                textAlign: "center",
                width: 80,
              }}
            >
              S.
              <br />
              NO.
            </TableCell>

            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Target name
            </TableCell>

            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Define
              <br />
              the
              <br />
              target
            </TableCell>

            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Metric
              <br />
              used to
              <br />
              set the
              <br />
              target and to
              <br />
              monitor
              <br />
              progress
            </TableCell>

            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Specify
              <br />
              quantitative/
              <br />
              qualitative target
            </TableCell>

            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Period
            </TableCell>

            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Base
              <br />
              period
              <br />
              from which
              <br />
              progress is
              <br />
              measured
            </TableCell>

            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Milestones
              <br />
              and interim
              <br />
              targets
            </TableCell>

            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Performance
              <br />
              and trends
            </TableCell>

            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Target revisions
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {answer.map((row, idx) => {
            const name =
              row?.targetNameIFRS ?? row?.targetName ?? row?.name ?? "";

            const define =
              row?.defineTargetIFRS ??
              row?.defineTarget ??
              row?.definition ??
              "";

            const metric =
              row?.metricUsedMonitorIFRS ??
              row?.metricUsedToSetTargetAndMonitorProgress ??
              row?.metricUsed ??
              "";

            const specify =
              row?.specifyQuantQualTargetIFRS ??
              row?.specificQuantQualTargetIFRS ?? // fallback to earlier typo if present
              row?.specifyQuantitativeQualitativeTarget ??
              row?.targetSpec ??
              "";

            const period =
              row?.periodIFRS ?? row?.period ?? row?.timePeriod ?? "";

            const basePeriod =
              row?.basePeriodMeasuredIFRS ??
              row?.basePeriodFromWhichProgressIsMeasured ??
              row?.basePeriod ??
              "";

            const milestones =
              row?.milestonesInterimTargetsIFRS ??
              row?.milestonesAndInterimTargets ??
              row?.milestones ??
              "";

            const performance =
              row?.performanceTrendsIFRS ??
              row?.performanceAndTrends ??
              row?.performanceTrends ??
              "";

            const revisions =
              row?.targetRevisionsIFRS ??
              row?.targetRevisions ??
              row?.revisions ??
              "";

            return (
              <TableRow key={idx}>
                <TableCell sx={{ border: 1 }}>{idx + 1}.</TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {name}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {define}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {metric}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {specify}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {period}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {basePeriod}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {milestones}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {performance}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {revisions}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
  const renderAnticipatedFinancialEffectsViewTable = (answer = []) => (
    <TableContainer sx={{ mb: 3, borderRadius: 1, overflow: "hidden" }}>
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell
              rowSpan={2}
              sx={{ border: 1, fontWeight: 520, textAlign: "center" }}
            >
              Category
            </TableCell>
            <TableCell
              rowSpan={2}
              sx={{ border: 1, fontWeight: 520, textAlign: "center" }}
            >
              Current
              <br />
              financial
              <br />
              effects
            </TableCell>
            <TableCell
              colSpan={3}
              sx={{ border: 1, fontWeight: 520, textAlign: "center" }}
            >
              Anticipated financial effects
            </TableCell>
          </TableRow>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Short term
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Medium term
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Long term
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {answer.map((row, idx) => {
            const category = row?.categoryAFE ?? row?.category ?? "";
            const current =
              row?.currentFinancialEffectsAFE ??
              row?.currentFinancialEffects ??
              "";
            const shortT =
              row?.anticipatedShortAFE ??
              row?.anticipatedShort ??
              row?.shortTerm ??
              "";
            const mediumT =
              row?.anticipatedMediumAFE ??
              row?.anticipatedMedium ??
              row?.mediumTerm ??
              "";
            const longT =
              row?.anticipatedLongAFE ??
              row?.anticipatedLong ??
              row?.longTerm ??
              "";

            return (
              <TableRow key={idx}>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {category}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {current}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {shortT}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {mediumT}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {longT}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderClimateRiskMatrixViewTable = (answer = []) => {
    // compute category spans
    const counts = answer.reduce((acc, r) => {
      const cat = r?.categoryCRM ?? r?.category ?? "";
      if (!cat) return acc;
      acc[cat] = (acc[cat] || 0) + 1;
      return acc;
    }, {});
    const firstIndex = {};
    answer.forEach((r, i) => {
      const cat = r?.categoryCRM ?? r?.category ?? "";
      if (cat && firstIndex[cat] === undefined) firstIndex[cat] = i;
    });

    const cell = { border: 1, whiteSpace: "pre-line" };

    return (
      <TableContainer sx={{ mb: 3, borderRadius: 1, overflow: "hidden" }}>
        <Table sx={{ borderRadius: 1 }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
              <TableCell sx={{ ...cell, fontWeight: 520, textAlign: "center" }}>
                Category
              </TableCell>
              <TableCell sx={{ ...cell, fontWeight: 520, textAlign: "center" }}>
                Risk
              </TableCell>
              <TableCell sx={{ ...cell, fontWeight: 520, textAlign: "center" }}>
                Potential Impacts
                <br />
                (pre-defined)
              </TableCell>
              <TableCell sx={{ ...cell, fontWeight: 520, textAlign: "center" }}>
                Time period (short-
                <br />
                term / medium-term / long-term)
              </TableCell>
              <TableCell sx={{ ...cell, fontWeight: 520, textAlign: "center" }}>
                Whether applicable
                <br />
                for your company (Yes / No)
              </TableCell>
              <TableCell sx={{ ...cell, fontWeight: 520, textAlign: "center" }}>
                Additional details
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {answer.map((row, idx) => {
              const category = row?.categoryCRM ?? row?.category ?? "";
              const riskRaw = row?.riskCRM ?? row?.risk ?? "";
              const risk =
                row?.isOtherRowCRM || row?.isOtherRow
                  ? riskRaw || "Others (specify)"
                  : riskRaw;

              const impacts =
                row?.potentialImpactsCRM ?? row?.potentialImpacts ?? "";
              const period = row?.timePeriodCRM ?? row?.timePeriod ?? "";
              const applicable = row?.applicableCRM ?? row?.applicable ?? "";
              const details =
                row?.additionalDetailsCRM ?? row?.additionalDetails ?? "";

              const showCategory = category && firstIndex[category] === idx;
              const span = category ? counts[category] : 1;

              return (
                <TableRow key={idx}>
                  {showCategory && (
                    <TableCell
                      rowSpan={span}
                      sx={{
                        ...cell,
                        backgroundColor: "#ece6ea",
                        fontWeight: 600,
                        textAlign: "center",
                        minWidth: 160,
                      }}
                    >
                      {category}
                    </TableCell>
                  )}
                  <TableCell sx={cell}>{risk}</TableCell>
                  <TableCell sx={cell}>{impacts}</TableCell>
                  <TableCell sx={cell}>{period}</TableCell>
                  <TableCell sx={cell}>{applicable}</TableCell>
                  <TableCell sx={cell}>{details}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const renderElementsConsideredViewTable = (answer = []) => (
    <TableContainer sx={{ mb: 3, borderRadius: 1, overflow: "hidden" }}>
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Elements considered
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Yes / No
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              If yes, briefly explain
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {answer.map((row, idx) => {
            const label =
              row?.elementLabelEC ??
              row?.element ??
              row?.elementsConsidered ??
              "";
            const yesNo = row?.yesNoEC ?? row?.yesNo ?? row?.applicable ?? "";
            const explain =
              row?.explanationEC ??
              row?.explanation ??
              row?.details ??
              row?.briefExplanation ??
              row?.additionalDetails ??
              "";

            return (
              <TableRow key={idx}>
                <TableCell
                  sx={{
                    border: 1,
                    backgroundColor: "#ece6ea",
                    fontWeight: 600,
                    whiteSpace: "pre-line",
                  }}
                >
                  {label}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {yesNo}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {explain}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderEmissionsMeasurementViewTable = (answer = []) => (
    <TableContainer sx={{ mb: 3, borderRadius: 1, overflow: "hidden" }}>
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Type of emissions
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Amount (metric tonnes)
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Method used
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Measurement approach
              <br />
              (brief description)
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {answer.map((row, idx) => {
            const label =
              row?.typeLabelTE ?? row?.typeOfEmissions ?? row?.type ?? "";
            const amount =
              row?.amountMetricTonnesTE ??
              row?.amount ??
              row?.metricTonnes ??
              "";
            const method =
              row?.methodUsedTE ?? row?.methodUsed ?? row?.method ?? "";
            const approach =
              row?.measurementApproachTE ??
              row?.measurementApproach ??
              row?.approach ??
              "";

            return (
              <TableRow key={idx}>
                <TableCell
                  sx={{
                    border: 1,
                    backgroundColor: "#ece6ea",
                    fontWeight: 600,
                    whiteSpace: "pre-line",
                  }}
                >
                  {label}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {amount}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {method}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {approach}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderRiskOpportunityCategoryPercentageTable = (answer = []) => (
    <TableContainer sx={{ mb: 3, borderRadius: 1, overflow: "hidden" }}>
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Risk / Opportunity category
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Percentage of assets / activities
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {answer.map((row, idx) => {
            const category =
              row?.typeLabelERO ??
              row?.riskOpportunityCategoryROP ??
              row?.riskOpportunityCategory ??
              row?.category ??
              row?.type ??
              "";
            const percentage =
              row?.amountMetricTonnesERO ??
              row?.percentageAssetsActivitiesROP ??
              row?.percentageAssetsActivities ??
              row?.percentage ??
              row?.percent ??
              "";

            return (
              <TableRow key={idx}>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {category}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {percentage}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderTargetDetailsSimpleViewTable = (answer = []) => (
    <TableContainer sx={{ mb: 3, borderRadius: 1, overflow: "hidden" }}>
      <Table sx={{ borderRadius: 1 }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#d0c5ca" }}>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Target description
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Metric used
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Scope covered
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Time period
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Base year
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Interim milestones
            </TableCell>
            <TableCell sx={{ border: 1, fontWeight: 520, textAlign: "center" }}>
              Target type
              <br />
              (Absolute/Intensity)
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {answer.map((row, idx) => {
            const desc =
              row?.targetDescriptionTDT ??
              row?.targetDescriptionTDS ??
              row?.targetDescription ??
              row?.description ??
              "";
            const metric =
              row?.metricUsedTDT ??
              row?.metricUsedTDS ??
              row?.metricUsed ??
              row?.metric ??
              "";
            const scope =
              row?.scopeCoveredTDT ??
              row?.scopeCoveredTDS ??
              row?.scopeCovered ??
              row?.scope ??
              "";
            const period =
              row?.timePeriodTDT ??
              row?.timePeriodTDS ??
              row?.timePeriod ??
              row?.period ??
              "";
            const baseYear =
              row?.baseYearTDT ??
              row?.baseYearTDS ??
              row?.baseYear ??
              row?.baselineYear ??
              "";
            const milestones =
              row?.interimMilestonesTDT ??
              row?.interimMilestonesTDS ??
              row?.interimMilestones ??
              row?.milestones ??
              "";

            const type =
              row?.targetTypeTDT ??
              row?.targetTypeTDS ??
              row?.targetType ??
              row?.type ??
              "";

            return (
              <TableRow key={idx}>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {desc}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {metric}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {scope}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {period}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {baseYear}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {milestones}
                </TableCell>
                <TableCell sx={{ border: 1, whiteSpace: "pre-line" }}>
                  {type}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderBrsrTable = (condition, answer) => {
    const entry = brsrTableRegistry[condition];
    if (!entry || !entry.table) return null;

    const TableComponent = entry.table;
    const dataKey = entry.tableData;
    const setDataKey = entry.setTableData;

    const safeAnswer = Array.isArray(answer)
      ? answer
      : typeof answer === "object" && answer !== null
      ? answer
      : [];

    // Construct props dynamically
    const props = {
      [dataKey]: safeAnswer,
      [setDataKey]: () => {}, // dummy setter to avoid component crash
    };

    return <TableComponent {...props} />;
  };

  const renderTable = (answer, condition) => {
    if (!condition) {
      return renderTCFDTable(answer);
    }
    if (condition === "table_gri_1") {
      return renderAssetValueTable(answer);
    } else if (condition === "table_gri_2") {
      return renderMarketReservedTable(answer);
    } else if (condition === "table_gri_3") {
      return renderSupplierTable(answer);
    } else if (condition === "table_gri_4") {
      return renderDownStreamTable(answer);
    } else if (condition === "table_gri_5") {
      return renderLawRegulationsTable(answer);
    } else if (condition === "table_gri_6") {
      return renderMaterialTopicsTable(answer);
    } else if (condition === "table_sasb_aerospace_&_defence_1") {
      return renderCorruptionTable(answer);
    } else if (condition === "table_sasb_biotechnology_1") {
      return renderInitiativeTable(answer);
    } else if (condition === "table_sasb_biotechnology_2") {
      return renderDrugTable(answer);
    } else if (condition === "table_sasb_biotechnology_3") {
      return renderWorkforceTurnoverTable(answer);
    } else if (condition === "table_sasb_forestry_management_1") {
      return renderForestLandTable(answer);
    } else if (condition === "table_sasb_airlines_1") {
      return renderStrikesTable(answer);
    } else if (
      condition === "table_sasb_engineering_&_construction_service_1"
    ) {
      return renderworkforceTable(answer);
    } else if (condition === "table_sasb_iron_steel_1") {
      return renderPollutantEmissionTable(answer);
    } else if (condition === "table_sasb_iron_steel_2") {
      return renderworkforceTable(answer);
    } else if (condition === "table_sasb_iron_steel_3") {
      return renderRawSteelProductionTable(answer);
    } else if (condition === "table_sasb_chemicals_1") {
      return renderPollutantEmissionTable(answer);
    } else if (condition === "table_sasb_chemicals_2") {
      return renderWorkforceTable1(answer);
    } else if (condition === "table_sasb_chemicals_3") {
      return renderProcessSafetyMetricsTable(answer);
    } else if (condition === "table_sasb_advertising_&_marketing_1") {
      return renderEmployeeCategoryTable(answer);
    } else if (condition === "table_sasb_advertising_&_marketing_2") {
      return renderEmployeeCategoryTable1(answer);
    } else if (condition === "table_sasb_advertising_&_marketing_2") {
      return renderResilienceTable(answer);
    } else if (
      condition === "table_sasb_media_&_entertainment_1" ||
      condition === "table_sasb_media_&_entertainment_2"
    ) {
      return renderGenTable(answer);
    } else if (
      condition === "table_1" ||
      condition === "table_2" ||
      !condition
    ) {
      return renderTCFDTable(answer);
    } else if (condition?.startsWith("brsr_table_")) {
      return renderBrsrTable(condition, answer);
    } else if (!condition) {
      return renderTCFDTable(answer);
    } else if (condition === "table_sasb_software_&_it_services_1") {
      return renderWorkforceGenderTable(answer);
    } else if (condition === "table_sasb_software_&_it_services_2") {
      return renderWorkforceGroupTable(answer);
    } else if (condition === "table_sasb_car_rental_&_leasing_1") {
      return renderFleetFuelEconomyTable(answer);
    } else if (condition === "table_sasb_mortgage_finance_1") {
      return renderMortgageSummaryTable(answer);
    } else if (condition === "table_sasb_mortgage_finance_2") {
      return renderLoanResolutionTable(answer);
    } else if (condition === "table_sasb_mortgage_finance_3") {
      return renderBorrowerLTVTable(answer);
    } else if (
      condition === "table_sasb_solar_technology_&_project_developers"
    ) {
      return renderProjectDelayTable(answer);
    } else if (condition === "ifrs_table_1") {
      return renderRiskOpportunityTimeHorizonTable(answer);
    } else if (condition === "ifrs_table_2") {
      return renderRiskOpportunityEffectsTable(answer);
    } else if (condition === "ifrs_table_3") {
      return renderRiskActionsProgressTable(answer);
    } else if (condition === "ifrs_table_4") {
      return renderFinancialEffectsRiskTable(answer);
    } else if (condition === "ifrs_table_5") {
      return renderTimeHorizonABCTable(answer);
    } else if (condition === "ifrs_table_6") {
      return renderSustainabilityRiskAssessmentTable(answer);
    } else if (condition === "ifrs_table_7") {
      return renderTargetsDisclosureViewTable(answer);
    } else if (condition === "ifrs_table_8") {
      return renderClimateRiskMatrixViewTable(answer);
    } else if (condition === "ifrs_table_9") {
      return renderAnticipatedFinancialEffectsViewTable(answer);
    } else if (condition === "ifrs_table_10") {
      return renderElementsConsideredViewTable(answer);
    } else if (condition === "ifrs_table_11") {
      return renderEmissionsMeasurementViewTable(answer);
    } else if (condition === "ifrs_table_12") {
      return renderRiskOpportunityCategoryPercentageTable(answer);
    } else if (condition === "ifrs_table_13") {
      return renderTargetDetailsSimpleViewTable(answer);
    }
  };

  return (
    <DashboardLayout>
      <Grid container>
        <Box className={classes.buttonContainer}>
          <div className={classes.backContainer} onClick={navigateBack}>
            <ArrowBackIosIcon />
            Back
          </div>
        </Box>
        <Paper className={classes.container}>
          <Grid container>
            <Grid item xs={12}>
              <Typography sx={{ fontWeight: 550, mb: 10 }}>
                {data?.framework} Standards Questionnaire
              </Typography>
            </Grid>
            {filteredData?.length > 0 ? (
              (() => {
                let displayIndex = 0; // Counter for numbering
                return filteredData.map((item, index) => {
                  const isEmptyTable =
                    item.question_type === "table" && isTableEmpty(item.answer);
                  if (isEmptyTable) return null;

                  // Check if indexing should be skipped
                  const skipIndexing = questionsData.some(
                    (q) => q.id === item.question_id && q.question_id !== "None"
                  );

                  // Increment the numbering only if not skipping
                  if (!skipIndexing) displayIndex++;

                  return (
                    <Grid item xs={12} key={index} sx={{ marginBottom: 4 }}>
                      <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                        {/* Fixed width for numbering to ensure consistent alignment */}
                        <Box
                          sx={{
                            width: "30px",
                            flexShrink: 0,
                            textAlign: "center",
                            fontWeight: 520,
                          }}
                        >
                          {!skipIndexing ? `${displayIndex}.` : ""}
                        </Box>

                        {/* Question Text */}
                        <Box sx={{ flexGrow: 1 }}>
                          <Typography mb={1} fontWeight={520}>
                            {item.question_name}
                          </Typography>

                          {item.question_type === "table" ? (
                            renderTable(item.answer, item.condition)
                          ) : item.question_type === "" ? (
                            <></>
                          ) : (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                mt: 1,
                              }}
                            >
                              {/* Answer Label */}
                              <Box
                                sx={{
                                  flexShrink: 0,
                                  fontWeight: 520,
                                  minWidth: "70px",
                                }}
                              >
                                Answer:
                              </Box>

                              {/* Answer Content */}
                              <Box
                                sx={{
                                  flexGrow: 1,
                                  fontWeight: 430,
                                  marginLeft: 1,
                                }}
                              >
                                {Array.isArray(item.answer)
                                  ? item.answer
                                      .map((opt) => {
                                        const extra = item?.[opt];
                                        return extra ? `${opt} ${extra}` : opt;
                                      })
                                      .join(", ")
                                  : item.answer}

                                {item.other && (
                                  <Box sx={{ marginTop: 1, fontWeight: 430 }}>
                                    {item.other}
                                  </Box>
                                )}
                              </Box>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    </Grid>
                  );
                });
              })()
            ) : (
              <Typography>No answers available</Typography>
            )}
          </Grid>
        </Paper>
      </Grid>
    </DashboardLayout>
  );
}

export default ViewQuestionnaire;
